import React from 'react';
import { TabsLayout, TabsWrapper } from './style.js';

export default class Tabs extends React.Component {

  constructor(props) {
    super(props);
    this.state = { tabIndex: 0 };
  }

  setTabIndex(index) {
    this.setState({
      tabIndex: index
    });
  }

  render() {
    return (
      <TabsLayout>
        <div>
          <TabsWrapper>
            <ul>
              {this.props.tabs.map((tab, index) =>
                <li key={index} onClick={() => this.setTabIndex(index)} className={this.state.tabIndex === index ? 'active' : ''}>
                  <div>{tab}</div>
                </li>
              )}
            </ul>
          </TabsWrapper>
        </div>
        {this.props.children[this.state.tabIndex]}
      </TabsLayout>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/Tabs/index.jsx